module.exports = __webpack_public_path__ + "static/media/x_icon.a76469b3.svg";